

import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { inject } from 'mobx-react';
import _ from 'lodash';
import { translate } from 'react-i18next';
import Constants from '../../../common/Constants';
import MbAsiaReuseSelectionComponent from '../../BetslipComponent/AsiaView/MbAsiaReuseSelectionComponent';
import MbAsiaBetslipActions from '../../BetslipComponent/AsiaView/MbAsiaBetslipActions';
import MbNewAsiaBetslipActions from '../../BetslipComponent/AsiaView/MbNewAsiaBetslipActions';
import Utils from '../../../common/Utils';
import { withRouter } from 'react-router-dom';

@inject('BetslipStore', 'NewBetslipStore')
@withRouter
@translate([], { wait: true })
class ToastComponent extends Component {

  constructor(props) {
    super(props);
    this.setTimer = this.setTimer.bind(this);
    this.disableFooter = this.props.disableFooter
    this.state = {
      active: true,
    }
    this.isAsiaNewBetslip = window.env.enableNewBetslip && Utils.isMobileAsianView()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.toastId !== this.props.toastId) {
      this.setTimer();
    }
  }


  componentDidMount() {
    !this.props.disableTimer && this.setTimer();
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  setTimer() {
    // clear any existing timer
    if (this._timer != null) {
      clearTimeout(this._timer)
    }
    this._timer = setTimeout(
      function () {
        const { toastId, selectionType, id } = this.props
        this.props.removeTimeoutToast(toastId);
        this._timer = null;
        if (this.disableFooter) return;
        if (Utils.isMobileAsianView() && !this.props.BetslipStore.isSupportedPendingAcceptance) {
          MbAsiaBetslipActions.clearReuseSelection();
        } else if (this.isAsiaNewBetslip) {
          MbNewAsiaBetslipActions.clearReuseSelectionToast(selectionType, id)
        }
      }
        .bind(this),
      Constants.TOAST_TIMEOUT);
  }

  closeToast() {
    const { toastId, selectionType, id } = this.props
    this.props.removeTimeoutToast(toastId);
    !this.disableFooter && this.isAsiaNewBetslip && MbNewAsiaBetslipActions.clearReuseSingleSelectionToast(selectionType, id)
  }

  translate = (key) => {
    return this.props.t(key)
  }

  doRenderMessages() {
    let messageItems = [];
    _.forEach(this.props.messages, (message, index) => {
      const isError = message === Constants.TOAST.ERROR_MESSAGES || message === Constants.TOAST.MAX_TEASERS;
      const msg = isError ? this.translate('errors:' + message) : this.translate(message);
      messageItems.push(
        <p key={index} dangerouslySetInnerHTML={{ __html: msg }}></p>
      )
    })
    return messageItems;
  }

  doRenderInfo() {
    return this.props.matchInfo.map(match => <p className="match-info">{match}</p>)
  }

  renderTapToView = () => {
    const { tapOnLinkAction } = this.props
    let msg = this.translate('Tap to view')
    return (
      <div className="text-left tap_to_view_msg">
        <span onClick={() => tapOnLinkAction()}><u>{msg}</u></span>
      </div>
    )
  }

  handleReuseSelection = () => {
    switch (this.props.selectionType) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        MbNewAsiaBetslipActions.handleReuseSingleSelection(this.props.id, true)
        break
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        MbNewAsiaBetslipActions.handleReuseParlaySelection(undefined, true)
        break
      case Constants.ASIA_BETSLIP_TYPES.TEASER:
        MbNewAsiaBetslipActions.handleReuseTeaserSelection()
        if (this.props.isToast) {
          this.closeToast();
        }
        break
      default:
        break
    }
    this.props.clearAllToasts()
  }

  redirectToMyBets = () => {
    this.props.history.push('/' + Utils.getCurrentLang() + '/asian/my-bets')
    MbNewAsiaBetslipActions.handleExpandNewBetslip(false);
    this.props.clearAllToasts()
  }

  render() {
    const { className, tapOnLinkAction, isNewToast, toastStatus } = this.props
    return (
      <React.Fragment>
        <Container className={"toast-item " + (this.state.active ? 'active' : 'inactive') + (isNewToast ? ' new-toast-item-container' : '')}>
          <Row className={"toast-row no-gutters " + (className)}>
            <Col className={"toast-left bg-" + className}>
              {isNewToast
                ?
                <React.Fragment>
                  {
                    toastStatus === Constants.TOAST.TOAST_CLASS_ACTIVE ? <i class='fas fa-check-circle'></i>
                      : toastStatus === Constants.TOAST.TOAST_CLASS_ERROR ? <i className='fas fa-times-circle'></i>
                        : <i class='fas fa-exclamation-circle'></i>
                  }
                </React.Fragment>
                :
                <i className={"toast-icon mt-1 mb-1 icon-" + className}></i>
              }
            </Col>
            <Col>
              <Row className="toast-right-container">
                <Col className={"toast-middle " + className}>
                  <div>{this.doRenderMessages()}</div>
                  {this.props.matchInfo && this.props.matchInfo.length ?
                    <div className="mt-1">{this.doRenderInfo()}</div> :
                    undefined}
                  {tapOnLinkAction ? this.renderTapToView() : null}
                </Col>
                {isNewToast && !className.includes('warning')
                  && <Col xs={1} className="toast-right">
                    <i className="toast-icon icon-close" onClick={this.closeToast.bind(this)}></i>
                  </Col>}
              </Row>
              {
                this.props.BetslipStore.isFirstTimeBet &&
                className === Constants.TOAST.TOAST_CLASS_ACTIVE &&
                <MbAsiaReuseSelectionComponent closeToast={this.closeToast.bind(this)} isToast={true} />
              }
              {
                toastStatus === Constants.TOAST.TOAST_CLASS_ACTIVE && !this.disableFooter &&
                <div className='d-flex justify-content-between'>
                  <div className='viewMyBets_container'>
                    <a onClick={() => this.redirectToMyBets()} className='view-my-bets'>{this.translate('View in my bets')}</a>
                  </div>
                  <div className='reuseSelection_container'>
                    <a className='reuse-selection' onClick={() => this.handleReuseSelection()}>{this.props.t('Reuse selection')}</a>
                  </div>
                </div>
              }
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}
export default ToastComponent;


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/ToastComponent/index.js